import { forwardRef, useImperativeHandle, useState } from "react";
import Font from "@/src/components/base/Font";
import style from "./index.module.scss";
import { Color } from "@/src/styles/typescript/types/color";

const Snackbar = forwardRef(
  (
    props: {
      title: string;
      message: string;
      backgroundColor?: string;
      titleColor?: Color;
      textColor?: Color;
      autoClose?: boolean;
      timer?: number;
      icon?: string;
    },
    ref
  ) => {
    const [stateSB, setStateSB] = useState(false);

    useImperativeHandle(ref, () => ({
      show() {
        setStateSB(true);
        if (props?.autoClose) {
          setTimeout(
            () => {
              setStateSB(false);
            },
            props?.timer ? props?.timer - 200 : 2800
          );
        }
      },
    }));

    return (
      <div
        // id={"Alert_Snackbar"}
        className={`${style["box-alert"]}`}
        style={{ backgroundColor: props?.backgroundColor }}
        id={
          stateSB && props?.autoClose
            ? style?.show
            : stateSB && !props?.autoClose
            ? style?.showonly
            : style?.hide
        }
      >
        <div className={`${style["box-title-alert"]}`}>
          <img src={props?.icon} width={12} height={12} alt="warning-login" />
          <Font variant="subtitle-2-bold" color="white">
            {props.title}
          </Font>
        </div>

        <div style={{ paddingLeft: "20px" }}>
          <Font variant="body-1-medium" color="white">
            {props.message}
          </Font>
        </div>
      </div>
    );
  }
);

Snackbar.defaultProps = {
  title: "",
  backgroundColor: "#eb5757",
  timer: 3000,
  icon: `${process.env.CDN_URL}/images/main/mobile/warninglogin-icon.webp`,
};

export default Snackbar;
